export default Object.freeze({
  APP_NAME: 'Bluff&Catch',
  APP_NAME_ENG: 'Bluff&Catch'
})
